<template>
  <div>
    <div class="title-div">燃气开票</div>
    <div class="body-div" v-loading="loading">
      <div class="condition-div">
        <div class="left-cell">
          <el-select v-model="selectYear" class="accountSelect" placeholder="请选择" @change="onSelect">
            <el-option
              v-for="item in yearActions"
              :key="item.value"
              :label="item.label"
              :value="item.value">
            </el-option>
          </el-select>
          <el-input v-model="gasAccount" class="accountInput" placeholder="请输入燃气户号"></el-input>
          <el-button type="primary" class="selectBtn" @click="checkUserGas">查询</el-button>
        </div>
        <div class="right-cell">
          {{fillArr.length}}个缴费记录 已选中<span class="selected-quantity-span">{{checkArr.length}}</span>个
          <span class="select-all-span">全选</span>
          <!--<el-radio v-model="checked" label="1" @change="onCheck"></el-radio>-->
          <el-checkbox v-model="checkedAll" @change="onCheckAll"></el-checkbox>
        </div>
      </div>
      <div v-if="fillArr.length !== 0" class="invoice-div">
        <div v-for="(item, index) in fillArr" :key="index" class="invoice-card"
             :class="item.isChecked ? 'checked-card' : 'uncheck-card'" @click="onChildCheck(item)">
          <div class="date-div">{{item.payDT}}</div>
          <div class="money-div"><span class="money-span">{{item.payAmt}}</span>元</div>
        </div>
      </div>
      <div v-else class="no-data">暂无数据</div>
      <div class="subtotal-div">
        小计： <span class="subtotal-span">¥{{subtotal}}</span> <span class="unit-span">元</span>
      </div>
      <div class="button-div">
        <el-button type="primary" class="submit-button" @click="next()">下一步</el-button>
      </div>
    </div>
  </div>
</template>

<script>
  import { queryBilling } from '../../../api/bill'
  import { checkUserGas, getBjtongAccessToken, operationRecords } from '@/api/accountInformation'
  import { getToken } from '@/api/login'

  export default {
    name: 'GasInvoice',
    data () {
      return {
        yearActions: [], // 年份列表
        selectYear: '', // 年份
        checked: '', // 全选
        checkedAll: false, // 全选
        loading: false, // 是否显示加载提示
        obj: {}, // 选择的户号对象
        fillArrAdd: [], // 从后台获取的全部可开票记录
        fillArr: [], // 页面展示的可开票记录
        checkArr: [], // 选中的可开票记录
        gasAccount: '', // 燃气账户
        subtotal: '', // 小计
        telephone: '', // 登录时的用户名
        password: '', // 登录密码
        gasAccountInfo: {} // 户号信息
      }
    },
    created () {
      // this.onCheck()
      this.onCheckAll(false)
      this.getData()
    },
    mounted () {
      this.code = this.$route.query.code
      console.log('统一认证平台返回的code为pc端', this.code)
      this.getBjtongAccessToken(this.code)
    },
    watch: {
      checkArr (newVal, oldVal) {
        const that = this
        let add = 0
        newVal.forEach(item => {
          if (that.selectYear === '全部') {
            add = add + Number(item.payAmt)
          } else {
            const a = item.payDT.substring(0, 4)
            if (a == that.selectYear) {
              add = add + Number(item.payAmt)
            }
          }
        })
        this.subtotal = add.toFixed(2)
      }
    },
    methods: {
      // 下一步
      next () {
        if (this.checkArr.length === 0) {
          this.$message('请选择数据')
        } else {
          this.$router.push({
            name: 'PCGasInvoiceDetail',
            params: {
              arr: this.checkArr,
              gasAccountInfo: this.gasAccountInfo
            }
          })
        }
      },

      // 获取可开票记录
      getData () {
        const that = this
        that.loading = true
        const date = new Date()
        that.selectYear = date.getFullYear()
        // that.obj = that.$store.state.cardObj
        // const params = {
        //   'CM-FPAMT-QUERY': {
        //     acctId: that.obj.userCode,
        //     cardType: that.obj.meterType
        //   }
        // }
        const params = {
          'CM-FPAMT-QUERY': {
            acctId: that.gasAccountInfo.gasAccount,
            cardType: that.gasAccountInfo.meterType
          }
        }
        queryBilling(JSON.stringify(params)).then(res => {
          that.fillArrAdd = res.data['soapenv:Envelope']['soapenv:Body']['CM-FPAMT-QUERY'].results ? res.data['soapenv:Envelope']['soapenv:Body']['CM-FPAMT-QUERY'].results : []
          that.fillArr = [];
          that.fillArrAdd.forEach(item => {
            item['isChecked'] = false
            const a = item.payDT.substring(0, 4)
            if (a == that.selectYear) {
              that.fillArr.push(item)
            }
          })
          // 年份选择框数据
          const y = String(that.selectYear)
          const y1 = String(that.selectYear - 1)
          const y2 = String(that.selectYear - 2)
          that.yearActions = [{
            value: y,
            label: y
          }, {
            value: y1,
            label: y1
          }, {
            value: y2,
            label: y2
          }, {
            value: '全部',
            label: '全部'
          }]
          that.loading = false
        }).catch(() => {
          that.loading = false
          that.$message.error('开票记录查询失败')
        })
      },

      // 下拉框年份选择
      onSelect (action) {
        this.selectYear = action
        this.fillArr = []
        // this.checked = ''
        this.checkedAll = false
        if (action === '全部') {
          this.fillArr = [...this.fillArrAdd]
        } else {
          this.fillArrAdd.forEach(item => {
            const a = item.payDT.substring(0, 4)
            if (a == action) {
              this.fillArr.push(item)
            }
          })
        }
        // this.onCheck()
        this.onCheckAll(false)
      },

      // 全选单选框
      onCheck () {
        if (this.checkedAll == '1') {
          this.checkArr = [];
          this.fillArr.forEach(item => {
            item.isChecked = true
            this.checkArr.push(item)
          })
        } else {
          this.fillArr.forEach(item => {
            item.isChecked = false
          })
          this.checkArr = []
        }
        this.$forceUpdate()
      },

      // 全选
      onCheckAll(e) {
        if (e) {
          this.checkArr = [];
          this.fillArr.forEach(item => {
            item.isChecked = true
            this.checkArr.push(item)
          })
        } else {
          this.fillArr.forEach(item => {
            item.isChecked = false
          })
          this.checkArr = []
        }
        this.$forceUpdate()
      },

      // 缴费记录单选
      onChildCheck (val) {
        val.isChecked = !val.isChecked
        let flag = 0
        this.fillArr.forEach(item => {
          if (item.isChecked === false) {
            flag = 1
          }
        })
        if (flag === 0) {
          // this.checked = '1'
          this.checkedAll = true
        }
        if (val.isChecked) {
          this.checkArr.push(val)
        } else {
          const a = this.checkArr.indexOf(val)
          if (a !== -1) {
            this.checkArr.splice(a, 1)
          }
          // this.checked = ''
          this.checkedAll = false
        }
        this.$forceUpdate()
      },

      // 获取登录人的信息，根据账号密码获得北燃的token
      getBjtongAccessToken (code) {
        const that = this
        that.loading = true
        const params = {
          grantCode: code,
          operationType: '开发票'
        }
        getBjtongAccessToken(params).then(res => {
          if (res.data.success) {
            that.telephone = res.data.rows[0].userName
            that.password = res.data.rows[0].passwordEncrypted
            window.localStorage.userId = res.data.rows[0].id
            window.localStorage.userInfo = JSON.stringify(res.data.rows[0])
            that.toAccountNumberManagement()
          } else {
            that.$message.error(res.data.message)
          }
        }).catch(() => {
        })
      },

      // 登录
      toAccountNumberManagement () {
        const that = this
        const params = {
          client_id: 'a8117f61-0643-43ba-a172-bca68f497051',
          client_secret: 'a376a615-1ba6-453f-8e30-f68ae0b1b3f9',
          grant_type: 'password',
          // username: passwordEncryption(that.telephone),
          username: that.telephone,
          // password: passwordEncryption(that.password)
          // password: passwordEncryption('Bjtong')
          password: 'Bjtong'
        }
        getToken(params).then(res => {
          that.onLogin(res.data)
        }).catch(() => {
          this.$message.error('用户名或密码错误')
        })
      },

      // 获取token成功
      onLogin (resp) {
        window.localStorage.smartHistory = ''
        if (resp.access_token) {
          window.localStorage.tokenType = resp.token_type
          window.localStorage.token = resp.access_token
          this.loading = false
        } else {
          this.$message.error('获取token失败')
        }
      },

      // 校验户号并绑定
      checkUserGas () {
        const that = this
        if (that.gasAccount === '') {
          that.$message.warning('请输入燃气户号')
          return
        }
        that.loading = true
        const params = {
          userId: window.localStorage.userId,
          gasAccount: that.gasAccount
        }
        checkUserGas(params).then(res => {
          if (res.data.success) {
            if (res.data.rows[0].meterType == 'R') {
              that.gasAccountInfo = res.data.rows[0]
              that.onCheck()
              that.getData()
              that.loading = false
            } else {
              that.fillArr = []
              that.fillArrAdd = []
              that.checkArr = []
              that.isShowRecord = false
              that.loading = false
              that.$message({
                message: '开票只支持普表',
                type: 'warning',
                offset: 200
              });
            }
            that.operationRecords()
          } else {
            that.fillArr = []
            that.fillArrAdd = []
            that.checkArr = []
            that.isShowRecord = false
            that.$message.error(res.data.message)
            that.loading = false
          }
        }).catch(() => {
          that.loading = false
        })
      },

      // 记录用户操作类型
      operationRecords () {
        const that = this
        const params = {
          userId: window.localStorage.userId,
          gasAccount: that.gasAccount,
          operationType: '开发票'
        }
        operationRecords(params).then(res => {
          if (res.data.success) {
          } else {
            that.$message.error(res.data.message)
          }
        }).catch(() => {
        })
      }
    }
  }
</script>

<style scoped>
  .title-div {
    width: 88.5%;
    height: 158px;
    background: #BD1A2D;
    font-size: 38px;
    font-family: MicrosoftYaHei-Bold, MicrosoftYaHei;
    font-weight: bold;
    color: #FFFFFF;
    line-height: 158px;
    padding-left: 11.5%;
  }

  .body-div {
    padding: 32px 21% 80px 21%;
  }

  .condition-div {
    display: flex;
    align-items: center;
  }

  .left-cell {
    width: 50%;
  }

  .accountSelect{
    width: 36%;
  }

  .accountInput{
    width: 36%;
    margin-left: 1%;
  }

  .selectBtn{
    margin-left: 1%;
  }

  .right-cell {
    width: 50%;
    text-align: right;
    font-size: 16px;
    font-family: MicrosoftYaHei;
    color: #5C5C5C;
  }

  .selected-quantity-span {
    color: #BD1A2D;
  }

  /deep/ .el-radio__label {
    display: none;
  }

  .select-all-span {
    margin-left: 5%;
    margin-right: 2%;
  }

  /deep/ .el-radio__input.is-checked .el-radio__inner {
    border-color: #BD1A2D;
    background: #BD1A2D;
  }

  /deep/ .el-radio__inner:hover {
    border-color: #BD1A2D;
  }

  .invoice-div {
    display: flex;
    flex-wrap: wrap;
    justify-content: flex-start;
    margin-top: 32px;
  }

  .invoice-card {
    width: 31%;
    height: 61px;
    border-radius: 2px;
    display: flex;
    align-items: center;
    margin-bottom: 31px;
    margin-right: 2%;
  }

  .checked-card {
    background: #FFF6F6;
    box-shadow: 0px 2px 4px 4px rgba(238, 238, 238, 0.5);
    border: 1px solid #BD1A2D;
  }

  .uncheck-card {
    background: #FFFFFF;
    box-shadow: 0px 2px 4px 4px rgba(229, 229, 229, 0.5);
    border: 1px solid #DCDFE6;
  }

  .date-div {
    font-size: 16px;
    font-family: MicrosoftYaHei;
    color: #333333;
    width: 50%;
    padding-left: 9%;
  }

  .money-div {
    width: 50%;
    font-size: 16px;
    font-family: MicrosoftYaHei;
    color: #333333;
    text-align: right;
    padding-right: 11%;
  }

  .money-span {
    font-size: 18px;
    color: #BD1A2D;
  }

  .subtotal-div {
    font-size: 18px;
    font-family: MicrosoftYaHei-Bold, MicrosoftYaHei;
    font-weight: bold;
    color: #333333;
  }

  .subtotal-span {
    color: #BD1A2D;
  }

  .unit-span {
    font-size: 16px;
    font-weight: normal;
  }

  .submit-button {
    width: 35%;
    font-size: 18px;
    font-family: MicrosoftYaHei;
    color: #FFFFFF;
    height: 40px;
    padding: 0;
  }

  .el-button--primary {
    background-color: #BD1A2D;
    border-color: #BD1A2D;
  }

  .el-button--primary:focus, .el-button--primary:hover {
    background: #BD1A2D;
    border-color: #BD1A2D;
  }

  .el-button {
    border-radius: 0px 2px 2px 0px;
    border: 1px solid #BD1A2D;
  }

  .button-div {
    text-align: center;
    margin-top: 60px;
  }

  /deep/ .el-select .el-input__inner:focus {
    border-color: #BD1A2D;
  }

  /deep/ .el-select .el-input.is-focus .el-input__inner {
    border-color: #BD1A2D;
  }

  .el-select-dropdown__item.selected {
    color: #BD1A2D;
  }

  .no-data {
    width: 100%;
    margin-top: 32px;
    text-align: center;
    color: #62667A;
    font-size: 24px;
  }

  /deep/.el-checkbox__input.is-checked .el-checkbox__inner, /deep/.el-checkbox__input.is-indeterminate .el-checkbox__inner {
    background-color: #BD1A2D;
    border-color: #BD1A2D;
  }
</style>
